import React, { useEffect, useRef } from "react";
import WaveSurfer from "wavesurfer.js";

const Player = ({ audioFile }) => {
    const waveformRef = useRef(null); // 波形を描画する DOM 要素の参照
    const waveSurferRef = useRef(null); // WaveSurfer.js インスタンスの参照

    useEffect(() => {
        // WaveSurfer インスタンスの初期化
        waveSurferRef.current = WaveSurfer.create({
            container: waveformRef.current, // 波形を描画する DOM コンテナ
            waveColor: "grey", // 波形の色
            progressColor: "#1DA59F", // 再生中の波形の色
            cursorColor: "#1DA59F", // カーソルの色
            responsive: true, // レスポンシブ対応
            height: 60, // 波形の高さ
        });

        // オーディオファイルのロード
        waveSurferRef.current.load(audioFile);
        console.log(audioFile);

        return () => {
            // クリーンアップ処理で WaveSurfer インスタンスを破棄
            if (waveSurferRef.current) {
                console.log("destroyed");
                waveSurferRef.current.destroy();
                waveSurferRef.current = null;
            }
        };
    }, [audioFile]);

    // 再生/一時停止のトグル
    const handlePlayPause = () => {
        if (waveSurferRef.current) {
            waveSurferRef.current.playPause();
        }
    };

    return (
        <div ClassName="waveform-wrapper">
            {/* 波形を描画するコンテナ */}
            <div ref={waveformRef} style={{ width: "100%", margin: "20px 0" }}></div>
            {/* 再生/一時停止ボタン */}
            <button onClick={handlePlayPause}>Play / Pause</button>
        </div>
    );
};

export default Player;
